import { graphql, useStaticQuery } from "gatsby"
import { createContainer } from "lib/unstated"
import { useMemo } from "react"
import useIpTrace from "../hooks/useIpTrace"

const IPLocationState = () => {
  const { ipTraceInfo, loading } = useIpTrace()
  const { allStrapiCountries } = useStaticQuery(graphql`
    {
      allStrapiCountries {
        edges {
          node {
            locale
            code
            currencyCode
          }
        }
      }
    }
  `)

  const country = useMemo(() => ipTraceInfo?.loc || null, [ipTraceInfo])

  return {
    loading,
    country,
    locale: allStrapiCountries.edges.find(({ node }) => node.code === country)
      ?.locale,
  }
}

const IPlocationContainer = createContainer(IPLocationState)

export const IPLocationProvider = IPlocationContainer.Provider

export const useIPLocation = IPlocationContainer.useContainer
